<template>
  <v-container>
    <h1 class="text-h1 font-weight-thin mb-3">
      Omnibus {{ edition }}
    </h1>
    <v-card>
      <v-card-text>
        <p class="text-h2 text--primary font-weight-thin">
          Documents
        </p>
        <v-divider />
        <div class="d-flex justify-center flex-wrap pa-4">
          <v-card
            v-for="doc in docs"
            :key="doc.id"
            elevation="9"
            outlined
            max-width="344"
            class="ma-3"
          >
            <v-card-title class="text-h2">
              {{ doc.title }}
            </v-card-title>
            <v-card-text>
              <div class="grey--text text--darken-2">
                {{ doc.description }}
              </div>
            </v-card-text>
            <v-card-actions class="d-flex justify-center">
              <v-btn
                color="deep-orange"
                class="white--text"
                :disabled="!doc.file.url"
                @click="download(doc)"
              >
                Télécharger
              </v-btn>
            </v-card-actions>
          </v-card>
          <div v-if="!docs || !docs.length">
            Pas de document disponible.
          </div>
        </div>
        <div />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  import { get } from 'vuex-pathify'
  export default {
    computed: {
      edition: get('artifex/config.edition.edition'),
      docs: get('artifex/config.edition.omnibusDocs'),
    },
    methods: {
      download (doc) {
        const token = localStorage.getItem('jwt')
        window.open(`/nubium/${doc.file.url}?token=${token}`, '_blank')
      },
    },
  }
</script>
